import { deviceNames, Device } from '@ubnt/link-core/modules/devices';

export const meshDisabledItemFn = (device: Device) => {
  const consoles = [
    deviceNames.Dream_Router_5G_Max,
    deviceNames.Dream_Router,
    deviceNames.Dream_Router7,
    deviceNames.Dream_Wall,
  ];
  if (consoles.includes(device.name)) {
    return true;
  }
  return false;
};
